import cx from 'classnames';
import * as React from 'react';

import Box, { BoxSize } from 'components/Box';
import BoxBody from 'components/BoxBody';
import UnauthenticatedView, { Props as UnauthenticatedViewProps } from './UnauthenticatedView';

type Props = {
  size?: BoxSize;
} & UnauthenticatedViewProps;

export default function AuthenticationView({ className, size = 'xsmall', children, title }: Props) {
  return (
    <UnauthenticatedView title={title} className={cx('AuthenticationView', className)}>
      <Box size={size}>
        <BoxBody>{children}</BoxBody>
      </Box>
    </UnauthenticatedView>
  );
}
